module.exports = __webpack_public_path__ + "assets/images/11-2IGlJLD.jpg";